/**
 * Suppliers Module — Zod Validation Schemas
 */

import { z } from 'zod';

const supplierContactSchema = z.object({
  id: z.string(),
  name: z.string().min(1, 'suppliers.validation.contactNameRequired'),
  role: z.string().optional(),
  email: z.string().email('suppliers.validation.invalidEmail').optional().or(z.literal('')),
  phone: z.string().optional(),
  isPrimary: z.boolean(),
});

const paymentTermsSchema = z.object({
  type: z.enum(['immediate', 'net_15', 'net_30', 'net_60', 'net_90', 'custom']),
  customDays: z.number().min(1).optional(),
  currency: z.string().min(1),
  notes: z.string().optional(),
});

export const supplierFormSchema = z.object({
  name: z.string().min(1, 'suppliers.validation.nameRequired'),
  types: z.array(z.enum(['food_beverage', 'merchandise', 'equipment', 'services', 'general']))
    .min(1, 'suppliers.validation.typeRequired'),
  status: z.enum(['active', 'inactive', 'blocked']),
  taxId: z.string().optional(),
  legalName: z.string().optional(),
  address: z.string().optional(),
  city: z.string().optional(),
  state: z.string().optional(),
  country: z.string().optional(),
  postalCode: z.string().optional(),
  website: z.string().url('suppliers.validation.invalidUrl').optional().or(z.literal('')),
  email: z.string().email('suppliers.validation.invalidEmail').optional().or(z.literal('')),
  phone: z.string().optional(),
  contacts: z.array(supplierContactSchema).min(1, 'suppliers.validation.contactRequired'),
  paymentTerms: paymentTermsSchema,
  // Service-provider agreement (Services module) — optional, commercial only.
  agreementKind: z.enum(['none', 'net_rate', 'commission', 'markup']).optional(),
  agreementRate: z.number().min(0).optional(),
  defaultCostModel: z.enum(['flat', 'per_person', 'per_unit', 'per_leg']).optional(),
  notes: z.string().optional(),
});

export type SupplierFormSchema = z.infer<typeof supplierFormSchema>;
